import React from 'react';
import './App.css';
import {Globals} from './Globals';
import {Home} from './Home';
import {PageComments} from './PageComments';
import { recomputePane } from './computePane.js'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { tableSpec, translateCamino } from './tables.js'
import PData from './pData.js'

const pages = [
  "home", "completions", "age", "camino",  "countryFrom", "gender", "cityStarted",
  "countryStarted","profession", "reason", "travel", "spanishCityFrom"];

const caminos = ["All", "Frances", "Portugues", "Norte", "Primitivo",
"Ingles", "La Plata", "Finisterre", "Invierno", "Other"];

class App extends React.Component {
  state: any = {};
  chart: any = null;
  allCharts: any = [];
  cells: any = [];

  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 'home',
      currentCamino: 'All',
      showComments: true,
      showTable: true,
      showCharts: true,
    };
    Globals.appThis = this;
    // Fix PData
    for (var year in PData) {
      for (var month in PData[year]) {
        let newCaminos = PData[year][month].caminos.map(pair => {
          let camino = pair[0].trim().replace(/Portugu.s/, "Portugues")
          let tcamino = translateCamino[camino]
          if (!tcamino) tcamino = camino
          return [tcamino,pair[1]];
        })
        PData[year][month].caminos = newCaminos;
      }
    }
    this.chart = (<h1>No charts</h1>);
    console.log('PData', PData)
  }

  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  caminoButtons() {
    if (this.state.currentPage !== 'completions') return null;
    return (
      <div className="topline-menu">
        {caminos.map((camino, icamino) => (
          <button
            key={icamino}
            className={"topline-menu-btn "+(camino===this.state.currentCamino ? "selected-bg" : "btn-bg")}
            onClick={()=>{
              this.setState({currentCamino:camino});
            }}>
            {camino}
          </button>
        ))}
      </div>
    );
  }


  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  linkButtons() {
    let gotoPagebutton = (page, ipage, classes, title) => (
      <button
        key={ipage}
        className={classes}
        onClick={()=>{
          this.setState({currentPage:page});
        }}>
        {title}
      </button>
    )
    let buttons = [];
    pages.forEach((page,ipage) => {
      let abutton;
      if (typeof(page)==='string') {
        let title = tableSpec[page].title
        let classes = "topline-menu-btn "+(page===this.state.currentPage ? "selected-bg" : "btn-bg");
        abutton = gotoPagebutton(page, ipage, classes, title);
      } else {
        let ddName = 'dd' + page[0];
        abutton = (
          <div key={ipage} className="dropdown">
            <button
              onClick={()=>{
                document.getElementById(ddName).classList.toggle("show");
              }}
              className="topline-menu-btn btn-bg"
            >{'⬇︎'+page[0]}</button>
            <div id={ddName} className="dropdown-content">
              {page[1].map((spage,ispage) => gotoPagebutton(spage, ispage, 'topline-menu-btn btn-bg', tableSpec[spage].title))}
            </div>
          </div>
        )
      }
      buttons.push(abutton);
    });
    return (
      <div className="topline-menu">
        {buttons}
      </div>
    );
  }

  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  renderCell(s) {
    if (s === undefined) return  <span>...</span>
    let ret = <span>{s}</span>
    let len = s.length;
    if (s[len-1]==="%") {
      let sp = s.indexOf(' ');
      if (sp<0) return ret;
      return (
        <span>
          <span class="bold">{s.substring(sp+1)}</span>
          <span class="small08"> ({s.substring(0,sp)})</span>
        </span>
      )
    }
    return ret
  }

  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  renderContent() {
    // Home page is a special case
    if (this.state.currentPage === 'home') {
      return <Home />;
    }
    let columns = this.cells[0].map((h,i) => {
      return {
        Header: (
          <div style={{
            backgroundColor: 'rgb(255,248,210)',
            padding: '7px 5px',
          }}>
            {h}
          </div>
        ),
        id: h,
        accessor: (d) => d[i],
        Cell: row => (
          <div style={{
            backgroundColor: (i > 0) ? 'white' : 'rgb(255,248,210)',
            //width: (i > 0) ? '200px' : '350px',
            padding: '7px 5px',
          }}>
            {this.renderCell(row.value)}
          </div>
        )
      }
    })

    // Now put the data into a table.
    let data = this.cells.slice(1);
    let spec = tableSpec[this.state.currentPage]
    return (
      <ReactTable
        className='-striped -highlight'
        minRows={3}
        showPagination={spec.paging}
        showPaginationTop={spec.paging}
        showPaginationBottom={false}
        showPageSizeOptions={spec.paging}
        pageSizeOptions={[5, 10, 20, 25, 50, 100]}
        sortable={true}
        resizable={true}
        filterable={false}
        data={data}
        columns={columns}
      />
    );
  }

  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  showHideButton(name) {
    if (this.state.currentPage==='home') return null;
    let stateItem = 'show' + name;
    return (
      <button
        onClick={() => {
          let newValue = !this.state[stateItem]
          let newState;
          switch (name) {
            default: newState = {showComments:newValue}; break;
            case 'Table': newState = {showTable:newValue}; break;
            case 'Charts': newState = {showCharts:newValue}; break;
          }
          this.setState(newState)
        }}
        className="show-hide-btn"
      >
        {(this.state[stateItem] ? "Hide " : "Show ")+name}
      </button>
    )
  }

  //----------------------------------------------------------------------------
  //----------------------------------------------------------------------------
  render() {
    let ret = recomputePane(this.state.currentPage, this.state.currentCamino);
    this.cells = ret[0];
    this.allCharts = ret[1];
    return (
      <div className="app">
        {this.linkButtons()}
        {this.caminoButtons()}
        {this.showHideButton('Comments')}
        {this.state.showComments && PageComments(this.state.currentPage)}
        {this.showHideButton('Table')}
        {this.state.showTable && this.renderContent()}
        {this.showHideButton('Charts')}
        {this.state.showCharts && this.allCharts.map(chart=>chart)}
      </div>
    )
  }
}

export default App;

/*
**** Format of this.cells, returned by recomputePane *****
-- Each row is a table row
-- cells[0] is the row of column labels
-- cells[0][0] is a short title for the whole table
-- cells[0][1] is sometimes "2004-2017"
-- cells[0][2...] is 2017, 2016, 2015, ...
-- cells[1...N][0] is the row label
-- cells[1...N][1...] is the row data
-- cells.slice(1) is the data without the top row of column combinedLabels
-- cells.slice(1).map(row=>row.slice(1)) is the data without any labels
*/



// WEBPACK FOOTER //
// ./src/App.js